var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "careers",
      class: {
        mobile: _vm.isMobile(_vm.$mq),
        authenticated: _vm.isAuthenticated
      }
    },
    [
      !_vm.isAuthenticated
        ? _c("LandingHeaderV2", {
            staticClass: "header",
            attrs: {
              "ax-params": {
                ids: {
                  headerLogInBtn: "clicked_login_from_header",
                  stickyHeaderSignUpBtn:
                    "clicked_start_free_trial_from_careers",
                  stickyHeaderLogInBtn: "clicked_login_from_careers"
                }
              }
            }
          })
        : _c("AppHeader"),
      _vm._v(" "),
      _c("div", { staticClass: "container summary" }, [
        _c("header", [
          _c("h1", [_vm._v("Careers at Brilliant")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        We're proud of our mission and the business we've built around it. We work hard, and most\n        days we love our jobs. Every person has a huge impact on Brilliant and its direction.\n      "
            )
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn",
              on: {
                click: function($event) {
                  return _vm.scrollToOpenRoles()
                }
              }
            },
            [_vm._v("Explore open roles")]
          ),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src:
                "/site_media/version-1e29b0e536/images/company/careers/careers-header-2x.png"
            }
          })
        ]),
        _vm._v(" "),
        _vm._m(0)
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "container office" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "gallery" }, [
          _c(
            "div",
            {
              staticClass: "gallery-content",
              style: {
                transform: "translateX(" + _vm.currentGalleryScroll + "%)"
              }
            },
            [
              _vm._m(3),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _vm._m(5),
              _vm._v(" "),
              _vm._m(6)
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "scroll-left",
              attrs: { "aria-label": "Scroll left" },
              on: { click: _vm.scrollGalleryLeft }
            },
            [_c("span", { staticClass: "b-sprite-landing-chevron" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "scroll-right",
              attrs: { "aria-label": "Scroll right" },
              on: { click: _vm.scrollGalleryRight }
            },
            [_c("span", { staticClass: "b-sprite-landing-chevron" })]
          )
        ]),
        _vm._v(" "),
        _vm._m(7)
      ]),
      _vm._v(" "),
      _vm._m(8),
      _vm._v(" "),
      _vm._m(9),
      _vm._v(" "),
      _c("div", { ref: "openRolesAnchor", staticClass: "container" }, [
        _c("div", { staticClass: "divider" })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container roles", attrs: { id: "open-roles" } },
        [
          _vm._m(10),
          _vm._v(" "),
          _vm._l(_vm.categories, function(category) {
            return _c(
              "div",
              {
                key: category.name,
                staticClass: "team",
                class: { active: _vm.isTeamSectionOpen(category.name) }
              },
              [
                _c(
                  "div",
                  { staticClass: "team-description" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "category-title",
                        on: {
                          click: function($event) {
                            return _vm.toggleTeamSection(category.name)
                          }
                        }
                      },
                      [
                        _c("h3", [_vm._v(_vm._s(category.name))]),
                        _vm._v(" "),
                        category.icon_url
                          ? _c("img", {
                              attrs: {
                                src: category.icon_url,
                                alt: category.name
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._m(11, true)
                      ]
                    ),
                    _vm._v(" "),
                    _c("transition", { attrs: { name: "fade" } }, [
                      _vm.isTeamSectionOpen(category.name)
                        ? _c(
                            "div",
                            { staticClass: "team-description-content" },
                            [
                              _c("p", [_vm._v(_vm._s(category.description))]),
                              _vm._v(" "),
                              category.team_page
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "btn",
                                      attrs: { href: category.team_page }
                                    },
                                    [_vm._v("Go to team page")]
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("transition", { attrs: { name: "fade" } }, [
                  _vm.isTeamSectionOpen(category.name)
                    ? _c(
                        "ul",
                        { staticClass: "team-positions unstyled" },
                        _vm._l(category.positions, function(position, i) {
                          return _c("li", { key: i }, [
                            _c(
                              "a",
                              {
                                attrs: { href: position.url, target: "_blank" }
                              },
                              [_vm._v(_vm._s(position.name))]
                            ),
                            _vm._v(" "),
                            position.work_type || position.location
                              ? _c("span", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(position.work_type) +
                                      " " +
                                      _vm._s(
                                        position.work_type && position.location
                                          ? " - "
                                          : ""
                                      ) +
                                      "\n              " +
                                      _vm._s(position.location) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ])
                        }),
                        0
                      )
                    : _vm._e()
                ])
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("LandingFooter")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "summary-points" }, [
      _c("ul", { staticClass: "unstyled titles" }, [
        _c("li", [
          _c("h3", [_vm._v("A global team anchored in San Francisco")])
        ]),
        _vm._v(" "),
        _c("li", [_c("h3", [_vm._v("Dedicated to changing STEM learning")])]),
        _vm._v(" "),
        _c("li", [
          _c("h3", [_vm._v("High impact, "), _c("br"), _vm._v("low ego")])
        ])
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "unstyled descriptions" }, [
        _c("li", [
          _c("h3", { staticClass: "mobile-only" }, [
            _vm._v("A global team anchored in San Francisco")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n            50+ and growing, we work primarily in SF, with teammates in 10 states and 5 countries.\n            We have happy hour once a week, and monthly team events.\n          "
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("h3", { staticClass: "mobile-only" }, [
            _vm._v("Dedicated to changing STEM learning")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n            We care deeply about elevating math and science learning from something to be feared\n            to something that is motivating, inspiring and supportive.\n          "
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("h3", { staticClass: "mobile-only" }, [
            _vm._v("High impact, "),
            _c("br"),
            _vm._v("low ego")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n            We are fiercely protective of our culture, which values community, adventure,\n            kindness, candor, and a perpetual desire for knowledge.\n          "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "divider" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [_c("h2", [_vm._v("What’s the office like?")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "slide" }, [
      _c("div", { staticClass: "social width-1-2" }, [
        _c("div", { staticClass: "content" }, [
          _c("header", [
            _vm._v("\n                #art-team\n                "),
            _c("span", { staticClass: "count" }, [_c("span"), _vm._v("24")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "post" }, [
            _c("span", { staticClass: "avatar" }, [
              _c("span", {
                staticClass: "b-sprite-company-careers-tweet-avatar-1"
              })
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text" }, [
              _c("span", [_vm._v("Juliana")]),
              _vm._v(
                "\n                  before some of y’all logoff for thanksgiving PTO i’d like to GIVE my THANKS for\n                  having y’all as teammates, you’re all a joy to work with, our team meetings are\n                  always the best\n                "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "likes" }, [
            _c("span", {
              staticClass: "b-sprite-company-careers-tweet-likes-1"
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bg" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "img width-1-4" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-a9b7828734/images/company/careers/gallery-1-2x.png"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "social width-1-4" }, [
        _c("div", { staticClass: "content" }, [
          _c("header", [_vm._v("#dogs-from-home")]),
          _vm._v(" "),
          _c("div", { staticClass: "post" }, [
            _c("span", { staticClass: "avatar" }, [
              _c("span", {
                staticClass: "b-sprite-company-careers-tweet-avatar-2"
              })
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "text" }, [
              _c("span", [_vm._v("Blake")]),
              _vm._v(
                "\n                  Sun's out tongues out\n                  "
              ),
              _c("span", { staticClass: "img" }, [
                _c("span", {
                  staticClass: "b-sprite-company-careers-tweet-illustration-1"
                })
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "likes" }, [
            _c("span", {
              staticClass: "b-sprite-company-careers-tweet-likes-2"
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bg" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "img width-1-4" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-992426e67d/images/company/careers/gallery-2-2x.png"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "img width-1-4" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-6883de9cd1/images/company/careers/gallery-3-2x.png"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "img width-1-2" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-6152ab3cea/images/company/careers/gallery-4b-2x.png"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "slide slide-half" }, [
      _c("div", { staticClass: "img width-1-2" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-2150e57ac4/images/company/careers/gallery-5-2x.png"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "img width-1-2" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-5d298688ba/images/company/careers/gallery-6-2x.png"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "img width-1" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-1c8a3cc4cc/images/company/careers/gallery-7-2x.png"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "slide slide-half" }, [
      _c("div", { staticClass: "img width-1" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-1209a88310/images/company/careers/gallery-8-2x.png"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "slide slide" }, [
      _c("div", { staticClass: "img width-1-2" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-91c3f9c531/images/company/careers/gallery-9-2x.png"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "img width-1-4" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-d585a9dd40/images/company/careers/gallery-10-2x.png"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "img width-1-4" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-104fa4794f/images/company/careers/gallery-11-2x.png"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "img width-1-4" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-c6d9352667/images/company/careers/gallery-12-2x.png"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "img width-1-4" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-e20590adff/images/company/careers/gallery-13-2x.png"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "img width-1-2" }, [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-1e6d99fff9/images/company/careers/gallery-14-2x.png"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "vibes" }, [
      _c("div", [
        _c("h3", [_vm._v("Our vibe is more like this:")]),
        _vm._v(" "),
        _c("ul", { staticClass: "unstyled" }, [
          _c("li", [
            _c("span", { staticClass: "icon" }, [
              _c("span", { staticClass: "b-sprite-company-icon-morelike-1" })
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("Be surrounded by people who dance to their own beat.")
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "icon" }, [
              _c("span", { staticClass: "b-sprite-company-icon-morelike-2" })
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Propose answers, and assert what you think the best outcome would look like."
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "icon" }, [
              _c("span", { staticClass: "b-sprite-company-icon-morelike-3" })
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n              Grow in a relatively autonomous way – no one will tell you what to do or how to do\n              it.\n            "
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "icon" }, [
              _c("span", { staticClass: "b-sprite-company-icon-morelike-4" })
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n              Work in an environment with high intensity and velocity (but where we also take\n              plenty of vacation).\n            "
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "icon" }, [
              _c("span", { staticClass: "b-sprite-company-icon-morelike-5" })
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Be adventurous. The work may change every 6 months, but it will rarely be dull."
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "icon" }, [
              _c("span", { staticClass: "b-sprite-company-icon-morelike-6" })
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n              Enjoy freedom and mobility to move laterally to grow into domains you're interested\n              in.\n            "
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "icon" }, [
              _c("span", { staticClass: "b-sprite-company-icon-morelike-7" })
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Be surrounded by long-term people who are committed to our specific mission."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("h3", [_vm._v("...and less like this:")]),
        _vm._v(" "),
        _c("ul", { staticClass: "unstyled" }, [
          _c("li", [
            _c("span", { staticClass: "icon" }, [
              _c("span", { staticClass: "b-sprite-company-icon-lesslike-1" })
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Be surrounded by model citizens who prize degrees and accolades."
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "icon" }, [
              _c("span", { staticClass: "b-sprite-company-icon-lesslike-2" })
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("Have a very hands-on manager who has all the answers.")
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "icon" }, [
              _c("span", { staticClass: "b-sprite-company-icon-lesslike-3" })
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Have clearly-defined project goals and standards for success."
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "icon" }, [
              _c("span", { staticClass: "b-sprite-company-icon-lesslike-4" })
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Work in an environment where people strictly keep their 9-5 schedules"
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "icon" }, [
              _c("span", { staticClass: "b-sprite-company-icon-lesslike-5" })
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Methodically grow your career and portfolio without assuming undue risk."
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "icon" }, [
              _c("span", { staticClass: "b-sprite-company-icon-lesslike-6" })
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("Enjoy our vast library of corporate training resources.")
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", { staticClass: "icon" }, [
              _c("span", { staticClass: "b-sprite-company-icon-lesslike-7" })
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Command respect by wearing the Gooblesoft uniform – everyone knows Gooblesoft!"
              )
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "divider" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container people" }, [
      _c("header", [
        _c("h2", [_vm._v("What kinds of people work at Brilliant?")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "intro" }, [
        _c("div", { staticClass: "decoration" }, [
          _c("img", {
            attrs: {
              src:
                "/site_media/version-2d4c4a99c8/images/company/careers/team-1-2x.png"
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("p", [
            _vm._v(
              "\n          People at Brilliant typically share a strong sense of mission, desire for autonomy and\n          ownership over a domain, and a strong generalist skillset within a domain or across\n          domains.\n        "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n          People here are passionate about their (often wonkish) hobbies, delight in unique\n          creative portfolios, or have worked in some way to elevate educational outcomes.\n        "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n          As a team, we embrace diversity – of educational backgrounds, economic backgrounds,\n          race, gender, sexual orientation, and many other categories too numerous to name.\n        "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "experience" }, [
        _c("div", { staticClass: "decoration" }, [
          _c("div", { staticClass: "img" }, [
            _c("img", {
              attrs: {
                src:
                  "/site_media/version-d06570a663/images/company/careers/team-2-2x.png"
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "img" }, [
            _c("img", {
              attrs: {
                src:
                  "/site_media/version-b61ac4268d/images/company/careers/team-3-2x.png"
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "social" }, [
            _c("div", { staticClass: "content" }, [
              _c("header", [
                _vm._v("\n              #random\n              "),
                _c("span", { staticClass: "count" }, [_c("span"), _vm._v("42")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "post" }, [
                _c("span", { staticClass: "avatar" }, [
                  _c("span", {
                    staticClass: "b-sprite-company-careers-tweet-avatar-3"
                  })
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "text" }, [
                  _c("span", [_vm._v("Tara")]),
                  _vm._v(
                    "\n                I really wish I could thank someone for something right now\n              "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "post" }, [
                _c("span", { staticClass: "avatar" }, [
                  _c("span", {
                    staticClass: "b-sprite-company-careers-tweet-avatar-4"
                  })
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "text" }, [
                  _c("span", [_vm._v("Alice")]),
                  _vm._v(
                    "\n                you can thank us for being your friends\n              "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "bg" })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("h3", [_vm._v("Individuals at Brilliant have:")]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v("Consulted as a scientist for the TV shows CSI and Bones")
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("Worked as a professional electrician")]),
            _vm._v(" "),
            _c("li", [_vm._v("Won a global cryptography competition")]),
            _vm._v(" "),
            _c("li", [_vm._v("Built VR games")]),
            _vm._v(" "),
            _c("li", [_vm._v("Motorcycled across the country")]),
            _vm._v(" "),
            _c("li", [
              _vm._v("Published cutting-edge molecular biology research at SRI")
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("Dropped out of college")]),
            _vm._v(" "),
            _c("li", [
              _vm._v("Built interactive, 3D Viking ship models in Norway")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("Created art for Cards Against Humanity and Broad City")
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("Flown helicopters")]),
            _vm._v(" "),
            _c("li", [_vm._v("Started a high school … while in high school")]),
            _vm._v(" "),
            _c("li", [_vm._v("and more…")])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("h2", [_vm._v("Do you have any open roles?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        If our culture sounds fun and you see a way you can contribute, don't hesitate to email\n        "
        ),
        _c("a", { attrs: { href: "mailto:jobs@brilliant.org" } }, [
          _vm._v("jobs@brilliant.org")
        ]),
        _vm._v(".\n        "),
        _c("br"),
        _vm._v(
          "\n        We often hire for roles that aren't formally listed, or meet people early for roles that\n        may be open in the future.\n      "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "We highly encourage people from traditionally underrepresented groups to apply."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "mobile-only chevron" }, [
      _c("span", { staticClass: "b-sprite-landing-chevron" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }